__turbopack_context__.v({
  "button": "Button-module-scss-module__Sq7L-q__button",
  "variant-error": "Button-module-scss-module__Sq7L-q__variant-error",
  "variant-error-outlined": "Button-module-scss-module__Sq7L-q__variant-error-outlined",
  "variant-error-text": "Button-module-scss-module__Sq7L-q__variant-error-text",
  "variant-filled": "Button-module-scss-module__Sq7L-q__variant-filled",
  "variant-outlined": "Button-module-scss-module__Sq7L-q__variant-outlined",
  "variant-signup-flow-primary": "Button-module-scss-module__Sq7L-q__variant-signup-flow-primary",
  "variant-signup-flow-secondary": "Button-module-scss-module__Sq7L-q__variant-signup-flow-secondary",
  "variant-text": "Button-module-scss-module__Sq7L-q__variant-text",
  "variant-tonal": "Button-module-scss-module__Sq7L-q__variant-tonal",
});
